import "core-js/modules/web.timers.js";
import { defineComponent, ref, watch } from 'vue';
export default defineComponent({
  name: "TipsShowSuccess",
  props: {
    show: {
      type: Boolean,
      "default": false,
      required: true
    },
    text: {
      type: String,
      "default": ""
    }
  },
  emits: ['update:show', 'confirm'],
  setup: function setup(props, context) {
    /** @type {Number|null}*/
    var timer = ref(null);
    watch(function () {
      return props.show;
    }, function (val) {
      if (val === false) {
        clearTimeout(timer.value);
        timer.value = null;
      }
    });

    var hide = function hide() {
      if (!props.show) {
        return;
      }

      clearTimeout(timer.value);
      context.emit("update:show", false);
      context.emit("confirm", null);
    };

    var afterShow = function afterShow() {
      clearTimeout(timer.value);
      timer.value = setTimeout(function () {
        hide();
      }, 800);
    };

    return {
      timer: timer,
      hide: hide,
      afterShow: afterShow
    };
  }
});